"use client";

import { Crown } from "lucide-react";
import Link from "@/components/ui/Link";
import { useUi } from "@/components/ui/use-ui";
import { thumbBackground } from "@/lib/art";

/** Stand-in for the player on premium videos when the viewer has no subscription. */
export function PremiumLock({ seed, poster, loggedIn, checking }: { seed: string; poster?: string | null; loggedIn?: boolean; checking?: boolean }) {
  const t = useUi();
  return (
    <div className="theme-dark relative aspect-video w-full overflow-hidden bg-black max-md:-mx-3 max-md:w-[calc(100%+1.5rem)] md:max-w-[calc((100svh-190px)*16/9)] md:rounded-xl">
      {poster ? (
        // eslint-disable-next-line @next/next/no-img-element -- poster from the content CDN
        <img src={poster} alt="" className="absolute inset-0 size-full scale-110 object-cover opacity-60 blur-xl" />
      ) : (
        <div aria-hidden className="absolute inset-0 scale-110 blur-xl" style={{ backgroundImage: thumbBackground(seed) }} />
      )}
      <div className="absolute inset-0 grid place-items-center bg-black/30 p-4">
        {!checking && (
          <div className="glass-strong max-w-sm rounded-2xl px-6 py-6 text-center shadow-2xl">
            <span className="mx-auto grid size-12 place-items-center rounded-full bg-brand/15 text-brand-soft">
              <Crown size={22} />
            </span>
            <p className="mt-3 text-[18px] text-fg">{t.video.premiumVideo}</p>
            <p className="mt-1 text-[14px] text-muted">{t.video.subscribeToWatch}</p>
            <Link href="/subscription" className="mt-5 inline-flex h-11 items-center rounded-full bg-brand-strong px-6 text-[15px] font-medium text-white hover:bg-brand-deep">
              {t.video.getPremium}
            </Link>
            {!loggedIn && (
              <p className="mt-3 text-[13px] text-muted">
                {t.pay.alreadyMember}{" "}
                <Link href="/login" className="text-fg hover:underline">
                  {t.video.logIn}
                </Link>
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
